import { EXPLORE_ROUTES } from "../homeDashboard/exploreRoutes";
import React, { useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';
import ProfileImg from "../assets/images/expert2.png";
import Banner1 from "../assets/images/edit-banner.png";
import Banner2 from "../assets/images/edit-banner.png";
import Banner3 from "../assets/images/edit-banner.png";
import CategoryCard, { categorySliderSettings } from "./CategoryCard";
import DashboardTabSlider from "../dashboard/DashboardTabSlider";
import DashboardTabs from "../dashboard/DashboardTabs";
import DashboardSlider from "../dashboard/DashboardSlider";
import TestSeriesCard from "../dashboard/TestSeriesCard";
import DashboardTestCard from "../dashboard/DashboardTestCard";
import MultipleItemSlider from "../components/MultipleItemSlider";
import SliderCard from "../dashboard/SliderCard";
import LectureCard,  {lectureSliderSettings } from "../dashboard/LectureCard";
import GamesCard,  {GamesSliderSettings } from "../dashboard/GamesCard";
import RecentCard,  {RecentSliderSettings } from "../dashboard/RecentCard";
import StudentSelected from "../dashboard/StudentSelected";
import NeedSupportSection from '../components/NeedSupportSection';
import Footer from '../components/Footer';
import DashboardBannerSlider from "../dashboard/DashboardBannerSlider";
import useWindowWidth from "../hooks/useWindowWidth";
import Layout from "../layout/Layout";
// Select Exam Category Modal
import DashboradExamCatPopup from "../dashboard/DashboradExamCatPopup";
import DashboradMedicalModal from "../dashboard/DashboradMedicalModal";
import ChooseTemplateModal from "../components/ChooseTemplateModal";
import QuizOptionModal from "../components/QuizOptionModal";

import catBg from "../assets/images/exam-cat.png";
//Choose State Multiple Items
import bgImg1 from "../assets/images/bg1.png";
import bgImg2 from "../assets/images/bg2.png";
import bgImg3 from "../assets/images/bg3.png";
import bgImg4 from "../assets/images/bg4.png";
import starIcon from "../assets/images/bookmark.png";
import LogoIcon from "../assets/images/SliderLogo.png";

//Choose Exam Multiple Items
import examImg1 from "../assets/images/exambg1.png";
import examImg2 from "../assets/images/exambg2.png";
import examImg3 from "../assets/images/exambg3.png";
import examImg4 from "../assets/images/exambg4.png";

//What are you looking for
import Img1 from "../assets/images/im1.png";
import Img2 from "../assets/images/im2.png";
import Img3 from "../assets/images/im3.png";
import Img4 from "../assets/images/im4.png";

//Games and Challenges
import BattleImg from "../assets/images/battleImg.png";
import GroupBattle from "../assets/images/GroupBattle.png";
import RapidBattle from "../assets/images/RapidBattle.png";

//Test Series
import attemptedIcon from '../assets/images/test-icon1.png';
import testIcon3 from '../assets/images/test-icon3.png';
import attemptsIcon from '../assets/images/attemptsIcon.png';
import enrolIcon from '../assets/images/enrolIcon.png';

// Lectures 
import lect1 from '../assets/images/lect1.png';
import lect2 from '../assets/images/lect2.png';
import lect3 from '../assets/images/lect3.png';
import lect4 from '../assets/images/lect4.png';
import lect5 from '../assets/images/lect5.png';

// Dashboard State Choose Template Modal Popup Images
import Img5 from "../assets/images/im5.png";
import Img6 from "../assets/images/im6.png";
import Img7 from "../assets/images/im7.png";
import Img8 from "../assets/images/im8.png";

//Recent Activity
//Import SVg
import { SvgBg } from '../components/SvgIcons';

function Dashboard() {
  const slides = [
    { image: Banner1, title1: "Antique", title2: "sculpture", date: "June 12 – July 25" },
    { image: Banner2, title1: "Vintage Art", title2: "Exhibition", date: "Aug 10 – Aug 30" },
    { image: Banner3, title1: "Classic Heritage", title2: "Gallery", date: "Sept 5 – Sept 18" },
  ];

  //Choose State Multiple Slider 
  const states = [
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg1, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
    { name: "Arunachal Pradesh", location: "Itanagar", image: bgImg2, icon: LogoIcon, staricon: starIcon, isStarred: true, isSelected: true },
    { name: "Arunachal Pradesh", location: "Itanagar", image: bgImg3, icon: LogoIcon, staricon: starIcon, isStarred: true, isSelected: true,},
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg4, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false, },   
    { name: "Andhra Pradesh", location: "Amaravati", image:bgImg1, icon: LogoIcon,  staricon: starIcon, isStarred: false, isSelected: false,},   
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg2,  icon: LogoIcon, staricon: starIcon,  isStarred: false,  isSelected: false, },  
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg3, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false,},   
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg4, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false,},  
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg1, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false, },   
    { name: "Andhra Pradesh", location: "Amaravati", image: bgImg2,  icon: LogoIcon, staricon: starIcon, isStarred: false,  isSelected: false, },   
    { name: "Andhra Pradesh", location: "Amaravati", image:bgImg3, icon: LogoIcon,  staricon: starIcon, isStarred: false,  isSelected: false,},
  ];

// Choose Exam Multiple Slider
const exams = [
  { name: "SSC CGL", location: "Amaravati", image: examImg1, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "HP Patwari", location: "Itanagar", image: examImg2, icon: LogoIcon, staricon: starIcon, isStarred: true, isSelected: true },
  { name: "CDS Exam", location: "Dispur", image: examImg3, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg4, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg1, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg2, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg3, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false }, 
  { name: "SSC CGL", location: "Amaravati", image: examImg4, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg1, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false }, 
  { name: "SSC CGL", location: "Amaravati", image: examImg2, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg3, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false }, 
  { name: "SSC CGL", location: "Amaravati", image: examImg4, icon: LogoIcon,  staricon: starIcon,isStarred: false, isSelected: false }, 
  { name: "SSC CGL", location: "Amaravati", image: examImg1, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
  { name: "SSC CGL", location: "Amaravati", image: examImg2, icon: LogoIcon, staricon: starIcon, isStarred: false, isSelected: false },
];


 //MultipleItem Slider Setting
 const sliderSettings = {
  dots: false,
  infinite: false, 
  speed: 500,
  slidesToShow: 7.5,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: true,
  arrows: true,
  //  FIX SNAP 
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,

  responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 4.9 } },
    { breakpoint: 1200, settings: { slidesToShow: 4.5 } },
    { breakpoint: 991,  settings: { slidesToShow: 3.4 } },
    { breakpoint: 767,  settings: { slidesToShow: 2.9 } },
    { breakpoint: 576,  settings: { slidesToShow: 2.2 } },
    { breakpoint: 400,  settings: { slidesToShow: 1.9 } },
    { breakpoint:320,  settings: { slidesToShow: 1.1 } },
  ],
};

//Previous Year Slider
const sliderSettings1 = {
  dots: false,
  infinite: false, 
  speed: 500,
  slidesToShow: 4.9,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: true,
  arrows: true,
  
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,

   responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 3.9 } },
    { breakpoint: 1600, settings: { slidesToShow: 3.9 } },
    { breakpoint: 1400, settings: { slidesToShow: 3.2 } },
    { breakpoint: 1200, settings: { slidesToShow: 3.2 } },
    { breakpoint: 991,  settings: { slidesToShow: 2.3 } },
    { breakpoint: 767,  settings: { slidesToShow: 1.9 } },
    { breakpoint: 576,  settings: { slidesToShow: 1.6 } },
    { breakpoint: 400,  settings: { slidesToShow: 1.1 } },
// { breakpoint: 390,  settings: { slidesToShow: 1.1 } },
  ],
};
//What you are Looking For Content
  const width = useWindowWidth(); 
const categoriesItems = [
  { title: "Question bank", icon: Img1, bg: "#e8eafe" },
  { title: "Question bank", icon: Img2, bg: "#fef2dc" },
  { title: "Test Series", icon: Img3, bg: "#ffefeb" },
  { title: "PYP", icon: Img4, bg: "#d3f4dd" },
  { title: "Notes", icon: Img1, bg: "#ffcad1" },
  { title: "Lectures", icon: Img2, bg: "#fef2dc" },
  { title: "Blogs & Articles", icon: Img3, bg: "#ffcad1" },
  { title: "PYP", icon: Img4, bg: "#d3f4dd" },
  { title: "Notes", icon: Img1, bg: "#ffcad1" },
  { title: "PYP", icon: Img4, bg: "#d3f4dd" },
  { title: "Notes", icon: Img1, bg: "#ffcad1" },
  { title: "PYP", icon: Img4, bg: "#d3f4dd" },
  { title: "Notes", icon: Img1, bg: "#ffcad1" },
];

// Games and Challenges
 const gamesItems = [
  { title: "1 v/s 1 battle", image: BattleImg },
  { title: "Group battle", image: GroupBattle },
  { title: "Rapid Fire", image: RapidBattle },
  { title: "1 v/s 1 battle", image: BattleImg },
  { title: "Group battle", image: GroupBattle },
  { title: "Rapid Fire", image: RapidBattle },
  { title: "1 v/s 1 battle", image: BattleImg },
  { title: "Group battle", image: GroupBattle },
  { title: "Rapid Fire", image: RapidBattle },
  { title: "1 v/s 1 battle", image: BattleImg },
  { title: "Group battle", image: GroupBattle },
  { title: "Rapid Fire", image: RapidBattle },
  { title: "1 v/s 1 battle", image: BattleImg },
  { title: "Group battle", image: GroupBattle },
  { title: "Rapid Fire", image: RapidBattle },
  { title: "1 v/s 1 battle", image: BattleImg },
  { title: "Group battle", image: GroupBattle },
  { title: "Rapid Fire", image: RapidBattle },
  // you can add more cards here later
];


// Test Section Slider content
const tabContentData = {
  Tests: {
    Past: [
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: false, logo: true, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: false, logo: true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: null, badgeShield: true, dateRange: {start: "01-11-2023 11:12 AM", end:   "01-12-2023 11:12 AM"},  buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      // ... add more test past items here
    ],
    Ongoing: [],
    Upcoming: [],
  },

  // Quizzes Content
  Quizzes: {
    Past: [
      // paste your tests past data here, e.g.:
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: false, logo: true, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: false, logo: true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: null,  badgeShield: true,  dateRange: {start: "01-11-2023 11:12 AM", end:   "01-12-2023 11:12 AM"}, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      { free: true, logo: false, live: true, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], timer: "00.04.08", badgeShield: true, dateRange: null, buttonLabel: "Start Now" },
      // ... add more test past items here
    ],
    Ongoing: [],
    Upcoming: [],
  },
  //TestSeries
 TestSeries: {
    Past: [
      // paste your tests past data here, e.g.:
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon, enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon, enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon, enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon, enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon, enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon, enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      { logo: true, title: "RRB NTPC (CBT 1+CBT2) 2025 Mock Test Series", tests:"872", freeTests:"31 ", attempts:"76593", enrolments:"8000 ", langIcon:testIcon3, testsIcon:attemptedIcon, attemptsIcon:attemptsIcon,  enrolIcon:enrolIcon, languages: ["Hindi", "English"], badgeShield: true, buttonLabel: "View Test Series" },
      // ... add more test past items here
    ],
    Ongoing: [],
    Upcoming: [],
  },
};

//Prevoius Year Paper Section
const prevoiusYear = [
   { free: false, logo:true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: true, logo: false, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true,  dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now"  },
   { free: false, logo:true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: true, logo: false, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: false, logo:true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: true, logo: false, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392,  buttonLabel: "Start Now" },
   { free: false, logo:true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: true, logo: false, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: false, logo:true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: true, logo: false, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
   { free: false, logo:true, live: false, title: "Live Test : IOB Local Bank Officer 2025 (July 06 - 09)", duration: "180 Minutes", questions: 100, marks: 100, attempted: 19362, languages: ["Hindi", "English"], badgeShield: true, dateRange: null, aspirantsCount:true, attemptedCount: 392, buttonLabel: "Start Now" },
  ];

  // Lectures Content
   const lectures = [
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect1 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect2 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image:lect3 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect4 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect5 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image:lect1 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect2 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect3 },
  { title: "Lecture by new manages", category: "General Awareness", description: "Lorem Ipsum is simply dummy text of the printing and type.", time: "01:30 Hr", image: lect4 }
];

//Recent ACtivity Card Items
const recentItems = [
  { title: "Quizzes & PYPs", count: "0/50 Quizzes", color: "#fef2dc",  progress: "45" ,  Icon: SvgBg },
  { title: "Short Notes", count: "0/50 Notes", color: "#ffefeb", progress: "45", Icon: SvgBg },
  { title: "Lectures", count: "0/50 Lectures", color: "#d3f4dd",  progress: "45", Icon: SvgBg },
  { title: "Exam", count: "0/50 Exam", color: "#d6f6ff", progress: "45",  Icon:  SvgBg },
  { title: "Rapid Fire", count: "0/50 Rapid Fire", color: "#fee2ff",  progress: "45", Icon: SvgBg },
  { title: "Gamification", count: "0/50 Battles", color: "#ddebff",  progress: "45", Icon:  SvgBg },
  { title: "Articles & Blogs", count: "0/50 Blogs", color: "#ffcad1",  progress: "45", Icon: SvgBg },
  { title: "Quizzes & PYPs", count: "0/50 Quizzes", color: "#fef2dc",  progress: "45" ,  Icon: SvgBg },
  { title: "Short Notes", count: "0/50 Notes", color: "#ffefeb", progress: "45", Icon: SvgBg },
  { title: "Lectures", count: "0/50 Lectures", color: "#d3f4dd",  progress: "45", Icon: SvgBg },
  { title: "Exam", count: "0/50 Exam", color: "#d6f6ff", progress: "45",  Icon:  SvgBg },
  { title: "Rapid Fire", count: "0/50 Rapid Fire", color: "#fee2ff",  progress: "45", Icon: SvgBg },
  { title: "Gamification", count: "0/50 Battles", color: "#ddebff",  progress: "45", Icon:  SvgBg },
  { title: "Articles & Blogs", count: "0/50 Blogs", color: "#ffcad1",  progress: "45", Icon: SvgBg }
];

// chooseTemplate Popup
const chooseTemplateItems = [
  { title: "Question bank", icon: Img1, bg: "#e8eafe" , border:"#674EDD", action: { type: "route", path: "/question-bank" }},
  { title: "Test And Quizzes", icon: Img2, bg: "#fff2da" , border:"#FFDA93" ,  action: { type: "route", path: "/quizzes-pages"}},
  { title: "Short Notes", icon: Img3, bg: "#ffefeb" , border:"#FFC9BC"},
  { title: "Lecture", icon: Img5, bg: "#d3f4dd" , border:"#B1E3C0"},
  { title: "Rapid Fire", icon: Img6, bg: "#fee2ff" , border:"#FDC8FF"},
  { title: "Gamification", icon: Img8, bg: "#ddebff" , border:"#8CBBFF66"},
  { title: "Exams", icon: Img7, bg: "#d6f6ff" , border:"#8CD9FF"},
  { title: "Articles & Blogs", icon: Img4, bg: "#ffcad1" , border:"#F9ACB6"},
  { title: "Flash Card", icon: Img7, bg: "#f1ffea" , border:"#C1EDAC"},
];


//Dashboard Exam  Category Modal
const [showExamModal, setShowExamModal] = useState(false);
const [showMedicalModal, setShowMedicalModal] = useState(false);

//Dashboard State Choose Template Modal Popup 
const [showStateModal, setShowStateModal] = useState(false);
const [selectedState, setSelectedState] = useState(null);
 const [showCategoryModal, setShowCategoryModal] = useState(false);
const handleStateClick = (state) => {
  setSelectedState(state);
  setShowStateModal(true);
};

  return (
     <Layout>
   <div className="edit-profile min-vh-100">
     <div className="dashboard-rightSection">
      <div className="bannerContainer">

           {/* Exam Category & Medical Exam Section */}
  <div className="exam-container bgExam d-flex flex-column gap-3 flex-md-row align-items-start align-items-md-center w-100 gray-borderBottom examCat dash-view">

  {/* Left Section */}
  <div className="examCategory-Bg w-100">
  <div className="d-flex align-items-center flex-grow-1 center-border examinnerBg">
    <img
      src={catBg}
      alt="exam"
      className="exam-card-img"
    />

    <div className="ms-3 cat-space"  onClick={() => setShowExamModal(true)}>
      <h6 className="fw-bold mb-0 ">Select Exam Category</h6>
      <span className="exam-sub-link fw-medium text-white">
        Change Exam Category <i className="bi bi-chevron-right"></i>
      </span>
    </div>
    <div className="">
     <DashboradExamCatPopup
        show={showExamModal}
        onHide={() => setShowExamModal(false)}
      />
      </div>
  </div>
  </div>


  {/* Right Section */}
 
  <div className="medicalCategoryBg w-100 ">
  <div className="d-flex align-items-start medicalBg">
    {/* Image */}
    <div>
      <img src={catBg} alt="exam" className="exam-card-img" />
    </div>

    {/* Content */}
    <div className="ms-3 cat-space flex-grow-1" onClick={() => setShowMedicalModal(true)}>
      {/* First row: Medical Exam and View */}
      <div className="d-flex justify-content-between align-items-center w-100">
        <h6 className="fw-bold mb-0 blackText">Medical Exam</h6>
        <Link
          to=""
          className="view-link small text-decoration-none fw-semibold text-purple"
        >
          View <i className="bi bi-chevron-right"></i>
        </Link>
      </div>

      {/* Second row: Change Exam and Exam Date */}
      <div className="d-flex justify-content-between align-items-center w-100 mt-1">
        <span className="exam-sub-link fw-medium">
          Change Exam <i className="bi bi-chevron-right"></i>
        </span>

        <p className="mb-0 small grayText">
          Exam Date: <span className="fw-bold blackText">Coming Soon</span>
        </p>
      </div>
    </div>
      <div className="">
     <DashboradMedicalModal
        show={showMedicalModal}
        onHide={() => setShowMedicalModal(false)}
      />
      </div>
  </div>
</div>


</div>

        {/* Exam Category & Medical Exam Section */}

        <Row className="align-items-center profileBanner dashboardMT">
        
       {/* Slider Section */}
          {/* <Col md={12} xl={12} className="mobile-gap">
            <DashboardSlider slides={slides} />
          </Col> */}
      
      {/*  Banner Section */}
        <Col md={12} xl={12} className="BannerDashboard banner">
          <DashboardBannerSlider />
        </Col>
      {/* End Banner Section */}
      

      {/* Choose State Section */}
       <Col md={12} xl={12} className="mobile-gap">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="h4-title mb-0 fw-bold">Choose State</h4>
        <Link to={EXPLORE_ROUTES.states} className="text-decoration-none fw-bold showAll">
            Show all
        </Link>
      </div>
   <MultipleItemSlider
  items={states}
  settings={sliderSettings}
  renderItem={(item) => (
    <SliderCard
      item={item}
      onClick={() => setShowCategoryModal(true)}
    />
  )}
/>
            
      </Col>
  {/* Choose State Template Modal */}  
   <ChooseTemplateModal
        show={showCategoryModal}
        onHide={() => setShowCategoryModal(false)}
        items={chooseTemplateItems}
        onSelect={(item) => {
          setShowCategoryModal(false);
        }}
      />
  {/* End Choose State Template Modal */}  

      {/* End Choose State Section */}  

      {/* Choose Exam Section */}
     <Col md={12} xl={12} className=" mobile-gap">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="h4-title mb-0 fw-bold">Choose Exam</h4>
        <Link to={EXPLORE_ROUTES.states} className="text-decoration-none fw-bold showAll">
            Show all
        </Link>
      </div>
      <MultipleItemSlider
        items={exams}
        renderItem={(item) => <SliderCard item={item} />}
        settings={sliderSettings}
        />
      </Col>
      {/* End Choose Exam Section */}

        {/* Why Looking */}
         <Col md={12} xl={12}>
      <div className="category-section lookBg lookingBg">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h4 className="h4-title mb-0 fw-bold">What you are Looking For</h4>
        </div>

        {/* If width >= 768 → show slider */}
        {width >= 768 ? (
          <MultipleItemSlider
            items={categoriesItems}
            settings={categorySliderSettings}
            renderItem={(item) => <CategoryCard item={item} />}
          />
        ) : (
          /* Below 768 → Show 2-column grid */
          <div className="looking-grid">
            {categoriesItems.map((item, index) => (
              <div key={index} className="looking-grid-item">
                <CategoryCard item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </Col>
     
      {/* End Why Looking Section */}


      
        {/* Games & Challenges */}
          <Col md={12} xl={12} >
            <div className="category-section lookBg  GamesBg">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="h4-title mb-0 fw-bold">Games and Challenges</h4>
              </div>
           
        <MultipleItemSlider
          items={gamesItems}
          settings={GamesSliderSettings}
          renderItem={(item) => <GamesCard  item={item} />}
       />
            </div>
          </Col>
     
      {/* End Games & Challenges */}


        </Row>
    
      {/* Test Slider Section*/}
       <div className="dashboardTest-Slider">
          {/* <DashboardTabSlider categories={tabCategories} tabs={tabNames} data={tabContentData} /> */}
             <DashboardTabs
        title="Tests"
        tabs={["Past", "Ongoing", "Upcoming"]}
        data={tabContentData.Tests}
        renderCard={(item) => <DashboardTestCard item={item} />}
        link="/tests"
         bgClass="tab-bg-purple"
      />
        </div>

        {/* Quizzes Slider Section */}

        <div className="dashboardTest-Slider">
          {/* <DashboardTabSlider categories={tabCategories} tabs={tabNames} data={tabContentData} /> */}
            <DashboardTabs
              title="Quizzes"
              tabs={["Past", "Ongoing", "Upcoming"]}
              data={tabContentData.Quizzes}
              renderCard={(item) => <DashboardTestCard item={item} />}
               bgClass="tab-bg-peach"
            />
        </div>

        {/* Previous Year Papers Section */}
         <Col md={12} xl={12} className="">
            <div className="category-section  tabBg  PreviousBg">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="h4-title mb-0 fw-bold">Previous year papers</h4>
                <Link to={EXPLORE_ROUTES.states} className="text-decoration-none fw-bold showAll">
                    Show all
                </Link>
              </div>
            <MultipleItemSlider
                items={prevoiusYear}
                settings={sliderSettings1}
                renderItem={(item) => <DashboardTestCard item={item} />}
              />
             </div>  
         
         </Col>

         {/* End Previous Year Papers Section */}

        {/* Test Series Slider Section */}
          <div className="dashboardTest-Slider">
          {/* <DashboardTabSlider categories={tabCategories} tabs={tabNames} data={tabContentData} /> */}
            <DashboardTabs
              title="TestSeries"
              tabs={["Past", "Ongoing", "Upcoming"]}
              data={tabContentData.TestSeries}
              renderCard={(item) => <TestSeriesCard item={item} />}
               bgClass="tab-bg-ivoryPeach"
            />
        </div>
   
   {/*Lectures Section */}
      <Col md={12} xl={12} className="">
      <div className="category-section  lookBg  LecturesBg">
      <div className="d-flex align-items-center justify-content-between mb-3 ">
        <h4 className="h4-title mb-0 fw-bold">Lectures</h4>
         <Link to={EXPLORE_ROUTES.states} className="text-decoration-none fw-bold showAll">
            Show all
        </Link>
      </div>
      <MultipleItemSlider
          items={lectures}
          settings={lectureSliderSettings}
          renderItem={(item) => <LectureCard  item={item} />}
       />
    </div>        
  </Col>
    {/* End Lectures Section */}

    {/* Recent Activity */}
          <Col md={12} xl={12} >
            <div className="category-section lookBg  RecentBg">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="h4-title mb-0 fw-bold"> Recent Activity </h4>
              </div>
              <MultipleItemSlider
                items={recentItems}
                settings={RecentSliderSettings}
                renderItem={(item) => {
                  const IconComp = item.Icon;   
                  return <RecentCard item={item} IconComp={IconComp} />;
                }}
               />
            </div>
          </Col>
     
      {/* End Recent Activity */}

      {/* Student Selected Section */}
        <StudentSelected/>

        </div>
      {/* End Student Selected Section */}
      
    
      {/* Need Support and Footer Section*/}
       <div className="dashboard-footer">
          <NeedSupportSection />
          <Footer />
        </div>
      {/* End Need Support and Footer Section*/}
     
    
    </div>
       </div>
       </Layout>

  );
}

export default Dashboard;
